// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"52":"23cddcab96efd80b33a8","719":"c969f32fc944a5e25445"}[chunkId] + ".css";
};